// src/components/MenuPrincipal/MenuPrincipal.js
import React, { useState } from 'react';
import { GiHamburgerMenu } from "react-icons/gi";
import MenuModal from './components/MenuModal';
import '../../assets/css/menu.css';

const MenuPrincipal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className='menu-principal-module'>
      <div className='logo-principal'>
        <img 
          className='logo-img-principal' 
          src='/img/waldirpianos_preto.webp' 
          alt='Waldir Pianos'
        />
      </div>

      <div 
        className='menu-hamb'
        onClick={() => setIsModalOpen(true)}
      >
        <GiHamburgerMenu />
      </div>
      
      <MenuModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default MenuPrincipal;